module.exports = __webpack_public_path__ + "static/media/WATERDESCENT.59895ad1.png";